<template>
  <div class="container doInspectDrawer">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'todoInspectionDrawerList',
          title: '待装斗列表'
        },
        {
          name: 'doInspectDrawer',
          title: '生成清装斗记录'
        }
      ]"
      :btns="[
        {
          name: 'cancel',
          text: '取消',
        },
        {
          name: 'submit',
          text: '复核',
          type: 'primary'
        }
      ]"
      @btn-click="onBtnClick"
    >
      <div slot="info">
        <div class="info-container">
          <div class="info-item">
            <h4>收货单编码：{{purchaseReceipt.code}}</h4>
            <div>收货员：{{purchaseReceipt.createUserName}}</div>
            <div>创建时间：{{purchaseReceipt.createTime}}</div>
            <!-- <div>仓库：{{purchaseReceipt.supplierInventory}}</div> -->
            <div>运输方式：{{purchaseReceipt.transportMode}}</div>
            <div v-if="purchaseReceipt.transportModeId === 4">承运方式：{{purchaseReceipt.carryModeName}}</div>
            <div v-if="purchaseReceipt.transportModeId === 4">承运单位：{{purchaseReceipt.carrier}}</div>
            <div>车牌号：{{purchaseReceipt.licensePlate}}</div>
            <div>起运时间：{{purchaseReceipt.transTimeStart}}</div>
            <div>到货时间：{{purchaseReceipt.transTimeEnd}}</div>
            <div>随货同行单：{{purchaseReceipt.travelNo}}</div>
          </div>
          <div class="info-item">
            <h4>采购订单号：{{purchaseOrder.code}}</h4>
            <div>创建时间：{{purchaseOrder.createTime}}</div>
            <div>供应商：{{purchaseOrder.supplierName}}</div>
            <div>成本类型：{{purchaseOrder.paymentName}}</div>
          </div>
          <div class="info-item">
            <h4>采购计划单号：{{purchasePlan.code}}</h4>
            <div>商品类型：{{purchasePlan.goodsTypeName}}</div>
            <div>来源：{{purchasePlan.typeName}}</div>
            <div>采购人：{{purchasePlan.createUserName}}</div>
            <div>创建时间：{{purchasePlan.createTime}}</div>
          </div>
        </div>
      </div>

      <div slot="content">
        <lk-card title="采购商品详情">
          <div class="sum-wrap">
            <div class="title-amount">总商品数量</div>
            <div class="content-amount">{{goodsNum}}</div>
            <div class="title-money">总金额（元）</div>
            <div class="content-money">&yen;{{purchaseAmount}}</div>
          </div>
          <lk-table border :columns="columns" :data="tableData" class="plan-table"/>
        </lk-card>
        <lk-card title="清斗商品信息" class="clear-card">
          <lk-form :label-width='130' label-position="right">
            <lk-row class="reject-row" :gutter='16'>
              <lk-col span="24">
                <lk-form-item label="清斗信息:" class="ivu-form-item-required">
                  <lk-table border :columns="clearColumns" :data="tableData" class="plan-table"/>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card title="收货信息" class="other-card">
          <lk-form :label-width='130' label-position="right">
            <lk-row v-for="(item, index) in purchaseReceiptImgInfoList" :key="index" :gutter='16'>
              <lk-col span="10">
                <lk-form-item label="温度附件图:">
                  <Uploader :able="false" v-model="item.temperatureImg"></Uploader>
                </lk-form-item>
              </lk-col>
              <lk-col span="10" offset='2'>
                <lk-form-item label="温度图备注:">
                  <span>{{item.imgComment}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span="7">
                <lk-form-item label="供应商仓库名:" v-if="purchaseReceipt.supplierInventory">
                  <span>{{purchaseReceipt.supplierInventory}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" :offset="purchaseReceipt.supplierInventory ? 1 : 0">
                <lk-form-item label="运输方式:" v-if="purchaseReceipt.transportMode">
                  <span>{{purchaseReceipt.transportMode}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1" v-if="purchaseReceipt.transportModeId === 4">
                <lk-form-item label="承运方式:">
                  <span>{{purchaseReceipt.carryModeName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" :offset="purchaseReceipt.supplierInventory ? 0 : 1" v-if="purchaseReceipt.transportModeId === 4">
                <lk-form-item label="承运单位:">
                  <span>{{purchaseReceipt.carrier}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" :offset="purchaseReceipt.transportModeId === 4 ? 0 : 1">
                <lk-form-item label="车牌号:" v-if="purchaseReceipt.licensePlate">
                  <span>{{purchaseReceipt.licensePlate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <!--<lk-row :gutter='16'>
              <lk-col span="10">
                <lk-form-item label="车牌号:" v-if="purchaseReceipt.licensePlate">
                  <span>{{purchaseReceipt.licensePlate}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>-->
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
    <lk-modal
      v-model="checkShow"
      :width="451"
      @on-cancel="onCheckCancel"
      class="inspect-check-modal"
      title="复核人信息">
      <lk-form
        ref="checkForm"
        :model="checkInfo" :rules="ruleValidate" :label-width='114' label-position="right">
        <lk-form-item label="复核人姓名:" prop="account">
          <lk-input v-model="checkInfo.account"/>
        </lk-form-item>
        <lk-form-item label="口令:" prop="password">
          <lk-input v-model="checkInfo.password" type="password" class="input-password"/>
        </lk-form-item>
      </lk-form>
      <div slot="footer">
        <lk-button @click="onCheckCancel">取消</lk-button>
        <lk-button type="primary" @click="onCheckConfirm">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
// import AnTable from '../../components/table';
import Uploader from '../../components/Uploader.vue';
import user from '../../services/user';

export default {
  name: 'DoInspectDrawer',
  components: {
    BaseFrame,
    // AnTable,
    Uploader,
  },
  computed: {
    goodsNum() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += item.purchaseInspectionInfoPassNum;
      });
      return res.toFixed(2);
    },
    purchaseAmount() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += (item.purchaseInspectionInfoPassNum * item.purchaseReceiptInfoPriceBeforeTax);
      });
      return res.toFixed(2);
    },
  },
  data() {
    return {
      token: '',
      checkInfo: {
        account: '',
        password: '',
      },
      ruleValidate: {
        account: [
          {
            required: true, message: '请输入账号', trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: '请输入口令', trigger: 'blur' },
        ],
      },
      clearOptions: ['已售完', '入库清斗', '剩余清理'],
      checkShow: false,
      purchaseReceiptImgInfoList: [],
      paymentType: ['普通', '寄售'],
      queryParams: {
        purchaseOrderId: '',
      },
      purchaseReceipt: {},
      purchasePlan: {
        code: '',
      },
      purchaseOrder: {
        code: '',
        createUserName: '',
      },
      columns: [
        {
          title: '行号',
          width: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '通用名称',
          minWidth: 142,
          key: 'medicineInfoVoApprovedDrugNames',
        },
        {
          title: '规格',
          minWidth: 130,
          key: 'medicineInfoVoSpecifications',
        },
        {
          title: '产地',
          minWidth: 142,
          key: 'purchaseMedicineCountryOfOrigin',
        },
        {
          title: '生产企业',
          minWidth: 142,
          key: 'medicineInfoVoManufacturer',
        },
        {
          title: '上市许可持有人',
          minWidth: 142,
          key: 'medicineInfoVoMah',
        },
        {

          title: '批准文号',
          minWidth: 116,
          key: 'medicineInfoVoApprovalCode',
        },
        {
          title: '斗',
          minWidth: 120,
          render: (h, params) => {
            const defaultDrawerList = params.row.defaultDrawerList || [];
            const optionArr = defaultDrawerList.map(item => h('option', {
              domProps: {
                value: item.id,
              },
            }, item.locationCode));
            return h('select',
              {
                class: {
                  'dtp-select': true,
                },
                domProps: {
                  value: params.row.purchaseDrawerDetailLocationId,
                },
                on: {
                  change: (e) => {
                    this.changeInventory(params.index, e.target.value);
                  },
                },
              }, optionArr);
          },
        },
        {
          title: '剩余数量',
          minWidth: 82,
          key: 'purchaseDrawerDetailClearNum',
          render: (h, { row }) => {
            let resStr = '';
            if (!row.purchaseDrawerDetailClearGoodsStoreId) {
              resStr = '-';
            } else {
              if (row.purchaseDrawerDetailClearNum) {
                resStr += row.purchaseDrawerDetailClearNum;
              } else {
                resStr += 0;
              }
              if (row.clearMinPkgUnitName) {
                resStr += row.clearMinPkgUnitName;
              }
            }
            return h('div', resStr);
          },
        },
        {
          title: '清斗情况',
          minWidth: 120,
          render: (h, params) => {
            const optionArr = this.clearOptions.map(item => h('option', {
              domProps: {
                value: item,
              },
            }, item));
            return h('select',
              {
                class: {
                  'dtp-select': true,
                },
                domProps: {
                  value: params.row.clearRemark,
                },
                on: {
                  change: (e) => {
                    this.tableData[params.index].clearRemark = e.target.value;
                  },
                },
              }, optionArr);
          },
        },
        {
          title: '清斗质量情况',
          minWidth: 120,
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-change': (e) => {
                this.tableData[index].clearGoodsCondition = e.target.value;
              },
            },
            props: {
              value: row.clearGoodsCondition,
              placeholder: '请输入',
              maxlength: 100,
            },
          }),
        },
        {
          title: '清斗批号',
          minWidth: 82,
          key: 'purchaseDrawerDetailClearBatchCode',
          render: (h, { row }) => {
            let resStr = '';
            if (!row.purchaseDrawerDetailClearGoodsStoreId) {
              resStr = '-';
            } else {
              resStr = row.purchaseDrawerDetailClearBatchCode;
            }
            return h('div', resStr);
          },
        },
        {
          title: '装斗数量',
          minWidth: 82,
          render: (h, { row }) => h('div', row.purchaseReceiptInfoAcceptNum + row.purchaseMedicineDrugMinimumPackagingUnit),
        },
        {
          title: '装斗质量情况',
          minWidth: 120,
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-change': (e) => {
                this.tableData[index].loadGoodsCondition = e.target.value;
              },
            },
            props: {
              value: row.loadGoodsCondition,
              placeholder: '请输入',
              maxlength: 100,
            },
          }),
        },
        {
          title: '批号',
          minWidth: 116,
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-change': (e) => {
                this.tableData[index].purchaseReceiptInfoGoodsBatchNum = e.target.value;
              },
            },
            props: {
              value: row.purchaseReceiptInfoGoodsBatchNum,
              placeholder: '请输入',
              maxlength: 30,
            },
          }),
        },
        {
          title: '生产日期',
          minWidth: 144,
          render: (h, { row, index }) => h('lk-date-picker', {
            on: {
              'on-change': (value) => {
                this.validateProduct(index, value);
                this.tableData[index].purchaseReceiptInfoProductionDate = value;
              },
            },
            class: {
              'is-expiry': row.isProdDateExpiry,
            },
            props: {
              value: row.purchaseReceiptInfoProductionDate,
              placeholder: '请选择',
              editable: false,
              options: {
                disabledDate(date) {
                  return date && date.valueOf() > Date.now();
                },
              },
            },
          }),
        },
        {
          title: '有效日期',
          minWidth: 144,
          render: (h, { row, index }) => h('lk-date-picker', {
            on: {
              'on-change': (value) => {
                this.tableData[index].purchaseReceiptInfoExpiryDate = value;
              },
            },
            props: {
              value: row.purchaseReceiptInfoExpiryDate,
              placeholder: '请选择',
              editable: false,
              placement: 'bottom-end',
              options: {
                disabledDate(date) {
                  return date && date.valueOf() < Date.now();
                },
              },
            },
          }),
        },
      ],
      clearColumns: [
        {
          title: '行号',
          width: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '通用名称',
          minWidth: 142,
          key: 'clearApprovedName',
          render: (h, { row }) => {
            let resStr = '';
            if (!row.purchaseDrawerDetailClearGoodsStoreId) {
              resStr = '-';
            } else {
              resStr = row.clearApprovedName;
            }
            return h('div', resStr);
          },
        },
        {
          title: '批号',
          minWidth: 82,
          key: 'purchaseDrawerDetailClearBatchCode',
          render: (h, { row }) => {
            let resStr = '';
            if (!row.purchaseDrawerDetailClearGoodsStoreId) {
              resStr = '-';
            } else {
              resStr = row.purchaseDrawerDetailClearBatchCode;
            }
            return h('div', resStr);
          },
        },
        {
          title: '规格',
          minWidth: 130,
          key: 'clearSpec',
          render: (h, { row }) => {
            let resStr = '';
            if (!row.purchaseDrawerDetailClearGoodsStoreId) {
              resStr = '-';
            } else {
              resStr = row.clearSpec;
            }
            return h('div', resStr);
          },
        },
        {
          title: '产地',
          minWidth: 142,
          key: 'clearOrigin',
          render: (h, { row }) => {
            let resStr = '';
            if (!row.purchaseDrawerDetailClearGoodsStoreId) {
              resStr = '-';
            } else {
              resStr = row.clearOrigin;
            }
            return h('div', resStr);
          },
        },
        {
          title: '剩余数量',
          minWidth: 82,
          key: 'purchaseDrawerDetailClearNum',
          render: (h, { row }) => {
            let resStr = '';
            if (!row.purchaseDrawerDetailClearGoodsStoreId) {
              resStr = '-';
            } else {
              if (row.purchaseDrawerDetailClearNum) {
                resStr += row.purchaseDrawerDetailClearNum;
              } else {
                resStr += 0;
              }
              if (row.clearMinPkgUnitName) {
                resStr += row.clearMinPkgUnitName;
              }
            }
            return h('div', resStr);
          },
        },
        {
          title: '处理方式',
          fixed: 'right',
          minWidth: 120,
          render: (h, params) => {
            let disabled = false;
            if (!params.row.purchaseDrawerDetailClearNum) {
              disabled = true;
              params.row.clearDrawerType = '';
            }
            const optionArr = [
              h('option', {
                domProps: {
                  value: 1,
                },
              }, '保留库存清斗'),
              h('option', {
                domProps: {
                  value: 2,
                },
              }, '报损剩余库存清斗'),
            ];
            return h('select',
              {
                class: {
                  'dtp-select': true,
                },
                domProps: {
                  value: params.row.clearDrawerType,
                  disabled,
                },
                on: {
                  change: (e) => {
                    this.tableData[params.index].clearDrawerType = e.target.value;
                  },
                },
              }, optionArr);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    validateProduct(index, value) {
      const item = this.tableData[index];
      const prodDate = utils.toTimestamp(value);
      const goodsStoreId = item.purchaseMedicineMedicineId;
      const data = {
        prodDate, goodsStoreId,
      };
      if (!data.prodDate) {
        item.isProdDateExpiry = false;
        return;
      }
      this.$store.commit('setDisableLoading', true);
      purchase.checkProdDate(data).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data.isProdDateExpiry == 1) {
            item.isProdDateExpiry = true;
            this.$Message.error('存在生产时证件已过期的商品，请更新证件/更正生产日期');
          } else {
            item.isProdDateExpiry = false;
          }
        }
      }).catch((err) => {
        item.isProdDateExpiry = false;
        utils.handleError(err);
      });
    },
    loginToken() {
      this.$refs.checkForm.validate((flag) => {
        if (flag) {
          user.reviewerToken(this.checkInfo).then((res) => {
            if (res.data.status === 200) {
              this.token = res.data.data;
              this.checkShow = false;
              this.onSubmit();
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请填写用户名或者口令');
        }
      });
    },
    onCheckCancel() {
      this.checkShow = false;
      this.$refs.checkForm.resetFields();
    },
    onCheckConfirm() {
      this.loginToken();
      // this.onSubmit();
    },
    changeInventory(index, value) {
      const defaultDrawerList = this.tableData[index].defaultDrawerList;
      let targetItem = {};
      defaultDrawerList.forEach((item) => {
        if (item.id == value) {
          targetItem = item;
        }
      });
      this.tableData[index].purchaseDrawerDetailWareHouseName = targetItem.warehouseName;
      this.tableData[index].purchaseDrawerDetailWareHouseId = targetItem.warehouseId;
      this.tableData[index].purchaseDrawerDetailLocationId = targetItem.id;
      this.tableData[index].purchaseDrawerDetailLocationCode = targetItem.locationCode;
      this.getDrawerInfo(targetItem.id, index);
    },
    resetImgList() {
      this.purchaseReceiptImgInfoList = [];
    },
    resetTableData() {
      this.tableData = [];
    },
    resetReceipt() {
      this.purchaseReceipt = {};
    },
    showAddRejectGoods() {
      this.addRejectGoodsModalShow = true;
    },
    onBtnClick(name) {
      if (name === 'cancel') {
        this.onCancel();
      } else if (name === 'submit') {
        let dataIsNotFilled = false;
        this.tableData.forEach((item) => {
          if (!item.clearRemark
            || !item.clearGoodsCondition
            || !item.loadGoodsCondition
            || !item.purchaseReceiptInfoGoodsBatchNum) {
            dataIsNotFilled = true;
          }
        });

        if (dataIsNotFilled) {
          this.$Message.error('请填写完整数据再提交');
          return;
        }

        this.checkShow = true;
      }
    },
    onSubmit() {
      // adapt data
      const purchaseMedicineInfoVoList = [];
      const purchaseReceipt = {
        id: this.purchaseReceipt.id,
      };
      let dateNotValidate = false;
      let dataIsNotFilled = false;
      this.tableData.forEach((item) => {
        const purchaseReceiptInfo = {
          id: item.purchaseReceiptInfoId,
          medicineId: item.purchaseReceiptInfoMedicineId,
        };
        const purchaseReceiptInfoProductionDate = utils.toTimestamp(item.purchaseReceiptInfoProductionDate);
        const purchaseReceiptInfoExpiryDate = utils.toTimestamp(item.purchaseReceiptInfoExpiryDate);
        const purchaseInspectionInfo = {
          passNum: item.purchaseReceiptInfoAcceptNum,
          goodsBatchNum: item.purchaseReceiptInfoGoodsBatchNum ? item.purchaseReceiptInfoGoodsBatchNum : '',
          prodDate: purchaseReceiptInfoProductionDate,
          expiryDate: purchaseReceiptInfoExpiryDate,
          wareHouseId: item.purchaseDrawerDetailWareHouseId,
          wareHouseName: item.purchaseDrawerDetailWareHouseName,
          locationId: item.purchaseDrawerDetailLocationId,
          locationCode: item.purchaseDrawerDetailLocationCode,
        };
        if (item.isProdDateExpiry) {
          dateNotValidate = true;
        }
        const purchaseMedicine = {
          id: item.purchaseMedicineId,
        };
        const purchaseDrawerDetail = {
          clearRemark: item.clearRemark,
          clearGoodsCondition: item.clearGoodsCondition,
          loadGoodsCondition: item.loadGoodsCondition,
          clearDrawerType: item.clearDrawerType,
        };
        if (!item.clearRemark
            || !item.clearGoodsCondition
            || !item.loadGoodsCondition
            || !purchaseInspectionInfo.goodsBatchNum) {
          dataIsNotFilled = true;
        }
        purchaseMedicineInfoVoList.push({
          purchaseReceiptInfo, purchaseInspectionInfo, purchaseMedicine, purchaseDrawerDetail,
        });
      });

      // 数据完整校验
      if (dataIsNotFilled) {
        this.$Message.error('请填写完整数据再提交');
        return;
      }
      if (dateNotValidate) {
        this.$Message.error('存在生产时证件已过期的商品，请更新证件/更正生产日期');
        return;
      }
      const data = {
        purchaseReceipt,
        purchaseMedicineInfoVoList,
        reviewer_token: this.token,
      };
      purchase.todoInspectionDrawerAdd(data).then((res) => {
        const code = res.data.status;
        if (code === 200) {
          this.$Message.success('提交成功');
          this.resetAll();
          this.closeLeavelModal().then(() => {
            this.jumpToList();
          });
        } else {
          this.$Message.error(res.data.error);
        }
      });
      // reset
    },
    resetAll() {
      this.resetImgList();
      this.resetTableData();
      this.resetReceipt();
    },
    closeLeavelModal() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.$store.commit('setLeaveModal', false);
          resolve();
        });
      });
    },
    jumpToList() {
      this.$router.push({
        name: 'todoInspectionDrawerList',
      });
    },
    onCancel() {
      // reset and jump
      this.resetAll();
      this.closeLeavelModal().then(() => {
        this.jumpToList();
      });
    },
    getDrawerInfo(locationId, index) {
      const data = {
        locationId,
      };
      if (!locationId) {
        this.tableData[index].purchaseDrawerDetailClearNum = '';
        this.tableData[index].clearMinPkgUnitName = '';
        this.tableData[index].purchaseDrawerDetailClearBatchCode = '';
        return;
      }
      this.$store.commit('setDisableLoading', true);
      purchase.getDrawerInfo(data).then((res) => {
        if (res.data.status === 200) {
          const resData = res.data.data;
          const {
            goodsNum, minPkgUnitName, batchCode, approvedName, origin, spec, goodsStoreId,
          } = resData;
          this.tableData[index].purchaseDrawerDetailClearNum = goodsNum;
          this.tableData[index].clearMinPkgUnitName = minPkgUnitName;
          this.tableData[index].purchaseDrawerDetailClearBatchCode = batchCode;
          this.tableData[index].clearApprovedName = approvedName;
          this.tableData[index].clearOrigin = origin;
          this.tableData[index].clearSpec = spec;
          this.tableData[index].purchaseDrawerDetailClearGoodsStoreId = goodsStoreId;
        }
      });
    },
    getData() {
      return new Promise((resolve, reject) => {
        this.queryParams.purchaseReceiptId = this.$route.params.purchaseReceiptId;
        const queryParams = Object.assign({}, this.queryParams);
        purchase.todoInspectionInfo(queryParams).then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            if (res.data.data.purchaseReceipt) {
              this.purchaseReceipt.createTime = utils.formatTime(res.data.data.purchaseReceipt.createTime, 'YYYY/MM/DD HH:mm');
              this.purchaseReceipt.createUserName = res.data.data.purchaseReceipt.createUserName;
              this.purchaseReceipt.code = res.data.data.purchaseReceipt.code;
              this.purchaseReceipt.supplierInventory = res.data.data.purchaseReceipt.supplierInventory;
              this.purchaseReceipt.transportMode = res.data.data.purchaseReceipt.transportMode;
              this.purchaseReceipt.transportModeId = res.data.data.purchaseReceipt.transportModeId;
              this.purchaseReceipt.carryModeName = res.data.data.purchaseReceipt.carryModeName;
              this.purchaseReceipt.carrier = res.data.data.purchaseReceipt.carrier;
              this.purchaseReceipt.licensePlate = res.data.data.purchaseReceipt.licensePlate;
              this.purchaseReceipt.travelNo = res.data.data.purchaseReceipt.travelNo;
              this.purchaseReceipt.id = res.data.data.purchaseReceipt.id;

              if (res.data.data.purchaseReceipt.transTimeStart) {
                this.purchaseReceipt.transTimeStart = utils.formatTime(res.data.data.purchaseReceipt.transTimeStart, 'YYYY/MM/DD HH:mm');
              }
              if (res.data.data.purchaseReceipt.transTimeEnd) {
                this.purchaseReceipt.transTimeEnd = utils.formatTime(res.data.data.purchaseReceipt.transTimeEnd, 'YYYY/MM/DD HH:mm');
              }
            }

            if (res.data.data.purchaseOrder) {
              this.purchaseOrder.code = res.data.data.purchaseOrder.code;
              this.purchaseOrder.supplierName = res.data.data.purchaseOrder.supplierName;
              this.purchaseOrder.paymentName = this.paymentType[res.data.data.purchaseOrder.payment - 1];
              this.purchaseOrder.createTime = utils.formatTime(res.data.data.purchaseOrder.createTime, 'YYYY/MM/DD HH:mm');
            }
            if (res.data.data.purchasePlan) {
              this.purchasePlan.code = res.data.data.purchasePlan.code;
              this.purchasePlan.goodsTypeName = res.data.data.purchasePlan.goodsTypeName;
              this.purchasePlan.createUserName = res.data.data.purchasePlan.createUserName;
              this.purchasePlan.createTime = utils.formatTime(res.data.data.purchasePlan.createTime, 'YYYY/MM/DD HH:mm');
              this.purchasePlan.typeName = res.data.data.purchasePlan.typeName;
            }
            res.data.data.purchaseMedicineInfoVoList.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              if (!result.purchaseReceiptInfoTax) {
                result.purchaseReceiptInfoTax = '';
              }
              if (!result.purchaseReceiptInfoTotalAmountWithoutTax) {
                result.purchaseReceiptInfoTotalAmountWithoutTax = '';
              }
              if (!result.medicineInfoVoManufacturer) {
                result.medicineInfoVoManufacturer = '';
              }
              if (!result.purchaseMedicineApprovalNumber) {
                result.purchaseMedicineApprovalNumber = '';
              }
              if (!result.purchaseInspectionInfoPassNum) {
                result.purchaseInspectionInfoPassNum = 0;
              }
              if (!result.purchaseReceiptInfoGoodsBatchNum) {
                result.purchaseReceiptInfoGoodsBatchNum = '';
              }
              if (!result.purchaseReceiptInfoProductionDate) {
                result.purchaseReceiptInfoProductionDate = '';
              }
              if (result.purchaseReceiptInfoProductionDate) {
                result.purchaseReceiptInfoProductionDate = utils.formatTime(result.purchaseReceiptInfoProductionDate, 'YYYY-MM-DD');
              }
              if (!result.purchaseReceiptInfoExpiryDate) {
                result.purchaseReceiptInfoExpiryDate = '';
              }
              if (result.purchaseReceiptInfoExpiryDate) {
                result.purchaseReceiptInfoExpiryDate = utils.formatTime(result.purchaseReceiptInfoExpiryDate, 'YYYY-MM-DD');
              }
              if (!result.purchaseDrawerDetailWareHouseId) {
                result.purchaseDrawerDetailWareHouseId = '';
              }
              if (!result.purchaseDrawerDetailLocationId) {
                result.purchaseDrawerDetailLocationId = '';
              }
              if (!result.purchaseDrawerDetailWareHouseName) {
                result.purchaseDrawerDetailWareHouseName = '';
              }
              if (!result.purchaseDrawerDetailLocationCode) {
                result.purchaseDrawerDetailLocationCode = '';
              }
              if (!result.purchaseDrawerDetailClearNum) {
                result.purchaseDrawerDetailClearNum = '';
              }
              if (!result.purchaseDrawerDetailClearBatchCode) {
                result.purchaseDrawerDetailClearBatchCode = '';
              }
              if (!result.clearMinPkgUnitName) {
                result.clearMinPkgUnitName = '';
              }
              result.clearRemark = '已售完';
              result.clearGoodsCondition = '';
              result.clearDrawerType = 1;
              result.loadGoodsCondition = '合格';
              if (!result.clearOrigin) {
                result.clearOrigin = '';
              }
              if (!result.clearSpec) {
                result.clearSpec = '';
              }
              if (!result.purchaseDrawerDetailClearBatchCode) {
                result.purchaseDrawerDetailClearBatchCode = '';
              }
              if (!result.clearApprovedName) {
                result.clearApprovedName = '';
              }
              result.isProdDateExpiry = false;
              console.log(result);
              this.tableData.push(result);
            });

            if (res.data.data.purchaseReceiptImgInfoList) {
              this.purchaseReceiptImgInfoList = res.data.data.purchaseReceiptImgInfoList;
            }
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
  },
  mounted() {
    this.getData().then(() => {
      this.$watch('tableData', () => {
        this.$store.commit('setLeaveModal', true);
      }, { deep: true });
    }).catch((err) => {
      utils.handleError(err);
    });
  },
};
</script>
<style lang="less">
.doInspectDrawer{
  .temp-img{
    height: 80px;
    width: 80px;
  }
  .other-card{
    margin-top: 30px;
  }
  .rejectTable{
    margin-bottom: 16px;
  }
  .clear-card{
    margin-top:12px;
  }
  .is-expiry{
    .ivu-input{
      border: 1px solid red;
    }
  }
}
.inspect-check-modal{
  .ivu-modal-wrap{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ivu-modal-header{
    padding: 11px 16px;
    .ivu-modal-header-inner{
      font-size: 12px;
    }
  }
  .ivu-modal-body{
    padding-right: 60px;
  }
}

</style>
